import { API } from 'aws-amplify'

export async function getUserRolesByTenantId(tenantId){
	let records = []
    try {
		const body = {
			tenantId
		}
		const response = await safeFunction(API.post)('rds', '/query/UserRole', { body })
		records = response.data
	} catch (error) {
		console.error(error)
        records = []
	}
    return records
}

export async function loadUsersWithRoles(tenantId, isMapped){
    let records = []
    try {
        const body = {
          tenantId,
          isMapped
        }
        const response = await safeFunction(API.post)('rds', '/query/UserRoleLink', { body })
        records = response.data
    } catch (error) {
        console.error(error)
        records = []
    }
    return records
}

export async function getUserRoleLinksByUserRoleId(userRoleId) {
    let records = []
    try {
        const body = {
            userRoleId
        }
        const response = await safeFunction(API.post)('rds', '/userRole/getUserRoleLinksByUserRoleId', { body })
        records = response.data
    } catch (error) {
        console.error(error)
        records = []
    }
    return records
}


export async function updateStripeCustomer(tenant, newBillingEmail){
	try{
		if(!tenant.stripeCustomerId || !newBillingEmail){
			return
		}
		const apiName = 'stripeSetup'
		const path = '/customer/' + tenant.stripeCustomerId
		const post = {
			body: {
				name: tenant.companyName,
				email: newBillingEmail,
				address:{
					city: tenant.addressCity,
					line1: tenant.addressLine1,
					line2: tenant.addressLine2,
					postal_code: tenant.addressZip,
					state: tenant.addressState
				}
			}
		}
		await safeFunction(API.put)(apiName, path, post)
	}catch(e){
		console.error(e)
		throw e
	}
}